/**
 Combinum.Global.Enums.FilterType
*/
export enum FilterType {
  SingleValue = 0,
  LessThan = 1,
  GreaterThan = 2,
  Range = 3
}